module.exports = __webpack_public_path__ + "img/Close.c97c3df1.svg";